/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Test_All_ExpiredInputs */

const th_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} อุปกรณ์หมดอายุแล้วและถูกลบออก ปิดแล้วเปิดการแจ้งเตือนใหม่เพื่อลงทะเบียนอุปกรณ์นี้อีกครั้ง`)
};

const en_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} device(s) had expired and have been removed. Turn notifications off and on again to re-register this one.`)
};

const ja_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}台の端末は期限切れのため削除されました。通知をオフにしてからオンに戻すと、この端末を登録し直せます。`)
};

const zh_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`有 ${i?.count} 台设备已过期并被移除。关闭再打开通知即可注册这一台。`)
};

const es_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dispositivo(s) habían caducado y se han eliminado. Desactiva y vuelve a activar las notificaciones para registrar este.`)
};

const pt_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dispositivo(s) tinham expirado e foram removidos. Desligue e ligue as notificações de novo para registrar este.`)
};

const id_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} perangkat sudah kedaluwarsa dan dihapus. Matikan lalu nyalakan notifikasi untuk mendaftarkan yang ini.`)
};

const fr_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} appareil(s) avaient expiré et ont été retirés. Désactivez puis réactivez les notifications pour enregistrer celui-ci.`)
};

const tl_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} device ang nag-expire na at inalis. Patayin at buksan ang mga notipikasyon para mairehistro ang isang ito.`)
};

const vi_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} thiết bị đã hết hạn và bị gỡ. Tắt rồi bật thông báo để đăng ký thiết bị này.`)
};

const ko_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}개 기기가 만료되어 삭제했습니다. 이 기기를 등록하려면 알림을 껐다가 다시 켜세요.`)
};

const de_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Gerät(e) waren abgelaufen und wurden entfernt. Schalte die Benachrichtigungen aus und wieder ein, um dieses zu registrieren.`)
};

const ru_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Устройств с истёкшим сроком: ${i?.count}, они удалены. Выключите и включите уведомления, чтобы зарегистрировать это.`)
};

const tr_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cihazın süresi dolmuştu ve kaldırıldı. Bunu kaydetmek için bildirimleri kapatıp açın.`)
};

const it_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dispositivi erano scaduti e sono stati rimossi. Disattiva e riattiva le notifiche per registrare questo.`)
};

const pl_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Urządzeń, którym wygasła ważność i zostały usunięte: ${i?.count}. Wyłącz i włącz powiadomienia, aby zarejestrować to urządzenie.`)
};

const uk_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пристроїв із вичерпаним терміном, які видалено: ${i?.count}. Вимкніть і ввімкніть сповіщення, щоб зареєструвати цей.`)
};

const hi_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} उपकरणों की अवधि समाप्त हो चुकी थी और वे हटा दिए गए। इसे दर्ज करने के लिए सूचनाएँ बंद करके फिर चालू करें।`)
};

const ar_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`انتهت صلاحية ${i?.count} من الأجهزة وأُزيلت. أوقف الإشعارات ثم شغّلها لتسجيل هذا الجهاز.`)
};

const ms_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} peranti telah luput dan dibuang. Matikan dan hidupkan pemberitahuan untuk mendaftarkan yang ini.`)
};

const bn_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}টি যন্ত্রের মেয়াদ শেষ হয়েছিল ও সরানো হয়েছে। এটি নিবন্ধন করতে বিজ্ঞপ্তি বন্ধ করে আবার চালু করুন।`)
};

const zh_tw2_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`有 ${i?.count} 台裝置已過期並被移除。關閉再開啟通知即可註冊這一台。`)
};

const zh_hk2_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`有 ${i?.count} 台裝置已過期並被移除。關閉再開啟通知即可註冊這一台。`)
};

const ur_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} آلات کی میعاد ختم ہو چکی تھی اور ہٹا دیے گئے۔ اسے درج کرنے کے لیے اطلاعات بند کر کے دوبارہ چالو کریں۔`)
};

const fa_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} دستگاه منقضی شده بود و حذف شد. برای ثبت این یکی اعلان‌ها را خاموش و دوباره روشن کنید.`)
};

const sw_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vifaa ${i?.count} vilikuwa vimeisha muda nao vimeondolewa. Zima kisha washa arifa ili kusajili hiki.`)
};

const nl_test_all_expired = /** @type {(inputs: Test_All_ExpiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} apparaten waren verlopen en zijn verwijderd. Zet de meldingen uit en weer aan om dit apparaat te registreren.`)
};

/**
* | output |
* | --- |
* | "{count} device(s) had expired and have been removed. Turn notifications off and on again to re-register this one." |
*
* @param {Test_All_ExpiredInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_all_expired = /** @type {((inputs: Test_All_ExpiredInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_All_ExpiredInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_all_expired(inputs)
	if (locale === "ja") return ja_test_all_expired(inputs)
	if (locale === "zh") return zh_test_all_expired(inputs)
	if (locale === "es") return es_test_all_expired(inputs)
	if (locale === "pt") return pt_test_all_expired(inputs)
	if (locale === "id") return id_test_all_expired(inputs)
	if (locale === "fr") return fr_test_all_expired(inputs)
	if (locale === "tl") return tl_test_all_expired(inputs)
	if (locale === "vi") return vi_test_all_expired(inputs)
	if (locale === "ko") return ko_test_all_expired(inputs)
	if (locale === "de") return de_test_all_expired(inputs)
	if (locale === "ru") return ru_test_all_expired(inputs)
	if (locale === "tr") return tr_test_all_expired(inputs)
	if (locale === "it") return it_test_all_expired(inputs)
	if (locale === "pl") return pl_test_all_expired(inputs)
	if (locale === "uk") return uk_test_all_expired(inputs)
	if (locale === "hi") return hi_test_all_expired(inputs)
	if (locale === "ar") return ar_test_all_expired(inputs)
	if (locale === "ms") return ms_test_all_expired(inputs)
	if (locale === "bn") return bn_test_all_expired(inputs)
	if (locale === "zh-TW") return zh_tw2_test_all_expired(inputs)
	if (locale === "zh-HK") return zh_hk2_test_all_expired(inputs)
	if (locale === "ur") return ur_test_all_expired(inputs)
	if (locale === "fa") return fa_test_all_expired(inputs)
	if (locale === "sw") return sw_test_all_expired(inputs)
	if (locale === "nl") return nl_test_all_expired(inputs)
	return en_test_all_expired(inputs)
});